/* eslint-disable eqeqeq */
import { AgGridAngular, ICellEditorAngularComp } from 'ag-grid-angular';
import { AgPromise, ColDef, IAfterGuiAttachedParams, ICellEditorComp, ICellEditorParams, IComponent } from 'ag-grid-community';
import { GridOptions } from 'ag-grid-community';
import { AfterViewInit, EventEmitter, Output, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { NavigationService } from '../../../navigation/navigation.service';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';
import { GamificationService } from '../gamification.service';
import { AddCoinRow, LocalizationMessages, Permissions, User, UserProfileDTO } from '../user-admin.model';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-gamification-detail-page',
    templateUrl: './gamification-detail-page.component.html',
    styleUrls: ['./gamification-detail-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class GamificationDetailPageComponent implements OnInit {
    @ViewChild('gamificationDetailPageGrid') agGrid: AgGridAngular;
    @Input() userProfile: UserProfileDTO;
    @Output() userProfileChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() userInfo: User;
    @Input() datatransfer: any;
    @Output() datatransferChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() currentPage: string;
    @Output() currentPageChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() badgeNum: number;
    @Input() admin: number;

    permissions: Permissions;
    title = "";
    // filter
    listFilter = "";
    // order by
    orderBy = "date";
    orderByRaw = "right";
    orderByRawA = "r";
    //editing bool
    isEditingCoin = false;
    isEditingGem = false;
    isEditingBadge = false;
    // new entries
    coinEntryAmount = 0;
    coinDescription = "";
    gemEntryAmount = "";
    gemDescription = "";
    // orders related
    ifShowOrderDetail: number[] = [];
    LocalizationMessages: LocalizationMessages;
    dataLoading = false;
    //used for adding new data
    selectedNewRow: AddCoinRow;
    isVisible: boolean;
    selectedHistoryType: number;
    LoginID: number;
    public gridOptions: GridOptions = {
        columnDefs: [],
        defaultColDef: {
            sortable: false,
            filter: true,
            resizable: true,
            editable: true,
        },
        rowData: [],
        rowHeight: 50,
        rowSelection: 'multiple',
        editType: 'fullRow',
        suppressClickEdit: true,
        accentedSort: true,
        animateRows: true,
        suppressCellFocus: true,
        suppressScrollOnNewData: true,
        suppressRowDeselection: true,
        enableRangeSelection: true,
        suppressAggFuncInHeader: true,
        groupIncludeFooter: true,
        groupDisplayType: 'multipleColumns',
        alwaysShowVerticalScroll: true,
        popupParent: document.querySelector("cv-gamification-page"),
        components: {
            showCellRenderer: (params) => {
                if (!params.value)
                    return null;
                const data = params.data;
                return `<div><div class="font-weight-bold">${data.TimeAgo}</div><div>Earned ${data.earnedDates.length} Times</div></div>`;
            },
            orderDetailCellRenderer: (params) => {
                if (!params.value)
                    return null;
                const data = params.data;
                return `<div class="font-weight-bold">${data.ProductQuantity}</div><div> ${data.ProductCost}</div>`;
            },
            singleClickEditRenderer: class {
                private eGui;
                private eButtonCancel;
                private buttonCancelClickListener;
                private eButtonSave;
                private buttonSaveClickListener;
                private params;
                private selectedNewRow;

                init?(params: ICellEditorParams): void | AgPromise<void> {
                    this.selectedNewRow = params.data;
                    this.params = params;

                    this.createGui();

                    // setup the button, first get reference to it
                    this.eButtonCancel = this.eGui.querySelector('#idCancelCoin');

                    // bind the listener so 'this' is preserved, also keep reference to it for removal
                    this.buttonCancelClickListener = this.onButtonCancelClicked.bind(this);

                    // add the listener
                    this.eButtonCancel.addEventListener('click', this.buttonCancelClickListener);

                    // setup the button, first get reference to it
                    this.eButtonSave = this.eGui.querySelector('#idSaveCoin');

                    // bind the listener so 'this' is preserved, also keep reference to it for removal
                    this.buttonSaveClickListener = this.onButtonSaveClicked.bind(this);

                    // add the listener
                    this.eButtonSave.addEventListener('click', this.buttonSaveClickListener);
                }

                createGui() {
                    const template =
                        '<span>' +
                        '<div id="idCancelCoin" class="sgCancelBtn cancel_btn">Cancel</div>' +
                        '<div id="idSaveCoin" class="sgCancelBtn cancel_btn" style="color:#0078AC">Save</div>' +
                        '</span>';

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = template;
                    this.eGui = tempDiv.firstElementChild;
                }

                getGui() {
                    return this.eGui;
                }

                destroy() {
                    this.eButtonCancel.removeEventListener('click', this.buttonCancelClickListener);
                    this.eButtonSave.removeEventListener('click', this.buttonSaveClickListener);
                }

                onButtonCancelClicked(e) {
                    this.selectedNewRow.IsEdit = false;
                    this.params.stopEditing(true);
                }

                onButtonSaveClicked(e) {
                    this.selectedNewRow.IsEdit = true;
                    this.params.stopEditing(true);
                }

                getValue() {
                    return "";
                }
            },
            amountClickEditRenderer: class {
                private eGui;
                private eInput;
                private maxLength = 100;
                //used for adding new data
                selectedNewRow: AddCoinRow = {
                    IsEdit: true,
                    CurrentPointsChange: 0,
                    GivenBy: '',
                    ImageID: 0,
                    LastDate: "",
                    TimeAgo: '',
                    data: {
                        AchievedAchievementID: 0,
                        AdminID: 0,
                        CompanyID: 0,
                        CurrentPointsChange: 0,
                        DateAvailable: '',
                        Description: "",
                        EventDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS').toString(),
                        Level: 0,
                        LoginID: 0,
                        ProfileTemplateID: 0,
                        ReservedPointsChange: 0,
                        SpendingPointHistoryID: 0,
                        isEditingCoin: false,
                    },
                    historyValue: 0,
                };

                init?(params: ICellEditorParams): void | AgPromise<void> {
                    this.selectedNewRow = params.data;
                    this.eGui = document.createElement('div');
                    this.eGui.className = 'h-100 w-100';
                    this.eGui.innerHTML = `<input class="h-100 w-100" value="${params.data.CurrentPointsChange}" maxlength="50" />`;
                    this.eInput = this.eGui.querySelector('input');
                    this.eInput.addEventListener('input', this.inputChanged.bind(this));
                }

                getGui(): HTMLElement {
                    return this.eGui;
                }

                destroy?(): void {
                    this.eInput.removeEventListener('click', this.eInput);
                }

                getValue() {
                    return this.selectedNewRow.data.CurrentPointsChange;
                }

                inputChanged(event) {
                    const val = event.target.value;
                    const hasPositiveNumbers = /^[0-9]+$/;
                    const hasNegativeNumbers = /^-[0-9]+$/;

                    if (hasPositiveNumbers.test(val) || hasNegativeNumbers.test(val)) {
                        this.selectedNewRow.CurrentPointsChange = val;
                    }
                    else if (val == '-')
                        this.selectedNewRow.CurrentPointsChange = val;
                    else if (val.length == 0) {
                        event.target.value = '';
                        this.selectedNewRow.CurrentPointsChange = 0;
                    }
                    else
                        event.target.value = this.selectedNewRow.CurrentPointsChange;
                }

                isValid(value) {
                    return value.length <= this.maxLength;
                }

                isCancelAfterEnd() {
                    return !this.isValid(this.eInput.value);
                }
            },
            descriptionClickEditRenderer: class {
                private eGui;
                private eInput;
                private maxLength = 100;
                private value = "";
                //used for adding new data
                // eslint-disable-next-line @typescript-eslint/member-ordering
                selectedNewRow: AddCoinRow = {
                    IsEdit: true,
                    CurrentPointsChange: 0,
                    GivenBy: '',
                    ImageID: 0,
                    LastDate: "",
                    TimeAgo: '',
                    data: {
                        AchievedAchievementID: 0,
                        AdminID: 0,
                        CompanyID: 0,
                        CurrentPointsChange: 0,
                        DateAvailable: '',
                        Description: "",
                        EventDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS').toString(),
                        Level: 0,
                        LoginID: 0,
                        ProfileTemplateID: 0,
                        ReservedPointsChange: 0,
                        SpendingPointHistoryID: 0,
                        isEditingCoin: false,
                    },
                    historyValue: 0,
                };

                init?(params: ICellEditorParams): void | AgPromise<void> {
                    this.selectedNewRow = params.data;
                    this.eGui = document.createElement('div');
                    this.eGui.className = 'h-100 w-100';
                    this.eGui.innerHTML = `<input class="h-100 w-100" value="${params.data.data.Description}" maxlength="50" />`;
                    this.eInput = this.eGui.querySelector('input');
                    this.eInput.addEventListener('input', this.inputChanged.bind(this));
                }

                getGui(): HTMLElement {
                    return this.eGui;
                }

                destroy?(): void {
                    this.eInput.removeEventListener('click', this.eInput);
                }

                getValue() {
                    return this.value;
                }

                inputChanged(event) {
                    const val = event.target.value;
                    this.value = val;
                }

                isValid(value) {
                    return value.length <= this.maxLength;
                }

                isCancelAfterEnd() {
                    return !this.isValid(this.eInput.value);
                }
            },
        },
        onCellClicked: (params) => {
            const colId = params.column.getId();

            if (colId.includes('toAssign')) {
                $(params.event.target).find("input").prop("checked", true); //update radio button
            }
        },
        onGridSizeChanged: (e) => {
            e.api.sizeColumnsToFit();
        },
        isExternalFilterPresent: () => !!this.listFilter,
        doesExternalFilterPass: (node) => {
            const tmpFilter = this.listFilter.toUpperCase();

            switch (this.currentPage) {
                case 'coin':
                    return ((node.data.data.Description && node.data.data.Description.toUpperCase().includes(tmpFilter)));
                    break;
                case 'gem':
                    return ((node.data.data.Description && node.data.data.Description.toUpperCase().includes(tmpFilter)));
                    break;
                case 'badge':
                    return ((node.data.badgeName && node.data.badgeName.toUpperCase().includes(tmpFilter)));
                    break;
                case 'order':
                    return ((node.data.OrderStatusName && node.data.OrderStatusName.toUpperCase().includes(tmpFilter)) ||
                        (node.data.Note && node.data.Note.toUpperCase().includes(tmpFilter))
                    );
                    break;
            }
            return true;
        },
        onRowEditingStopped: (event) => {
            this.dataLoading = true;
            const data = event.data;

            this.agGrid?.api.setGridOption('rowData', this.datatransfer);
            if (data.IsEdit) {
                const temp = {
                    AchievedAchievementID: 0,
                    AdminID: 0,
                    CompanyID: 0,
                    CurrentPointsChange: data.CurrentPointsChange,
                    DateAvailable: '',
                    Description: data.data,
                    EventDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS').toString(),
                    Level: 0,
                    LoginID: 0,
                    ProfileTemplateID: 0,
                    ReservedPointsChange: 0,
                    SpendingPointHistoryID: 0,
                    isEditingCoin: false,
                };
                data.data = temp;
                this.saveNewCoinEntryNewData(data);
            };
        }
    };

    constructor(
        private gameService: GamificationService,
        private uAService: UserAdminService,
        private locService: CVLocalizationService,
        private navService: NavigationService,
        private modalService: NgbModal
    ) { }

    ngOnInit(): void {
        this.initAsync();

        // user LoginID
        this.LoginID = this.userProfile.LoginID;

        for (const data of this.datatransfer) {
            this.ifShowOrderDetail.push(0);
        }

        this.loadData();
    }

    async initAsync() {
        this.permissions = await this.uAService.getLoginUserPermissions();

        const dic: Map<string, string> = await this.locService.GetSection("MarketPlace");

        this.LocalizationMessages = {
            Coins: dic.get("Coins"),
            Gems: dic.get("Gems"),
            Recent_Market_Orders: dic.get("Recent_Market_Orders"),
            Badges: dic.get("Badges"),
            Processing: dic.get("Processing"),
            Intransit: dic.get("Intransit"),
            Shipped: dic.get("Shipped"),
            ReadyForPickUp: dic.get("Ready_For_Pickup"),
            Complete: dic.get("Complete"),
            Cancelled: dic.get("Cancelled"),
            Checkout_Error: dic.get("Checkout_Error"),
            Gems_Amount: dic.get("Gems_Amount"),
            Gems_Awarded_By: dic.get("Gems_Awarded_By"),
            Gems_Date: dic.get("Gems_Date")
        };

        const mainWindow = $('#GDPMainWindow');
        const listContainer = $('#game_detail_list_container');
        switch (this.currentPage) {
            case 'coin':
                this.title = (this.LocalizationMessages != undefined) ? this.LocalizationMessages.Coins : "Coins";
                mainWindow.width('50%');
                listContainer.height('70%');
                break;
            case 'gem':
                this.title = (this.LocalizationMessages != undefined) ? this.LocalizationMessages.Gems : "Gems";
                mainWindow.width('50%');
                listContainer.height('70%');
                break;
            case 'order':
                this.title = (this.LocalizationMessages != undefined) ? this.LocalizationMessages.Recent_Market_Orders
                    : "Recent Market Place Orders";
                mainWindow.width('60%');
                listContainer.height('100%');
                this.datatransfer = this.datatransfer.reverse();

                break;
            case 'badge':
                this.title = (this.LocalizationMessages != undefined) ? this.LocalizationMessages.Badges : "Badges";
                mainWindow.width('50%');
                listContainer.height('70%');
                break;
        }
        this.updateColumnDefs();
    }

    show() {
        this.loadData();
        this.isVisible = true;
    }

    hide() {
        this.isVisible = false;
        this.selectedHistoryType = 0;
    }

    close() {
        if (this.agGrid?.api == undefined || this.agGrid?.api.getEditingCells().length == 0) {
            this.currentPage = 'main';
            this.currentPageChange.emit('main');
            return;
        }
    }

    changeOrder(dir) {
        switch (dir) {
            case 'r':
                if (this.orderByRawA == 'r') {
                    this.orderByRawA = '-r';
                    this.orderByRaw = '-right';
                    this.orderBy = 'LastDate';
                } else {
                    this.orderByRawA = 'r';
                    this.orderByRaw = 'right';
                    this.orderBy = '-LastDate';
                }
                break;
            case 'l':
                if (this.orderByRawA == 'l') {
                    this.orderByRawA = '-l';
                    this.orderByRaw = '-left';
                    if (this.currentPage == 'badge') {
                        this.orderBy = '-badgeName';
                    } else if (this.currentPage == 'coin') {
                        this.orderBy = '-data.CurrentPointsChange';
                    } else if (this.currentPage == 'gem') {
                        this.orderBy = '-data.CurrentGemsChange';
                    }
                }
                else {
                    this.orderByRawA = 'l';
                    this.orderByRaw = 'left';
                    if (this.currentPage == 'badge') {
                        this.orderBy = 'badgeName';
                    } else if (this.currentPage == 'coin') {
                        this.orderBy = 'data.CurrentPointsChange';
                    } else if (this.currentPage == 'gem') {
                        this.orderBy = 'data.CurrentGemsChange';
                    }
                }
                break;
            case 'm':
                if (this.orderByRawA == 'm') {
                    this.orderByRawA = '-m';
                    this.orderByRaw = '-middle';
                    if (this.currentPage == 'badge') {
                        this.orderBy = '-badgeDescription';
                    } else {
                        this.orderBy = '-GivenBy';
                    }
                }
                else {
                    this.orderByRawA = 'm';
                    this.orderByRaw = 'middle';
                    if (this.currentPage == 'badge') {
                        this.orderBy = 'badgeDescription';
                    } else {
                        this.orderBy = 'GivenBy';
                    }
                }
                break;
        }
    }

    async saveCoinEntry() {
        this.agGrid?.api.setGridOption('rowData', this.datatransfer);
        if (!isNaN(this.coinEntryAmount)) {
            if (this.coinDescription.includes("/")) {
                this.coinDescription = this.coinDescription.replace(/\//g, "");
            }
            if (this.coinDescription == "") {
                this.coinDescription = "None";
            }
            await this.gameService.addSpendingHistory(this.userProfile.LoginID, this.coinDescription, this.coinEntryAmount);
            this.datatransfer = await this.uAService.getCurrencyHistory(this.userProfile.LoginID);
            this.datatransferChange.emit(this.datatransfer);
            this.userProfile = await this.uAService.getUserProfile(this.userProfile.LoginID);
            this.userProfileChange.emit(this.userProfile);
        }
    };

    // order details
    expandOrder(index) {
        if (this.ifShowOrderDetail[index] == 0) {
            this.ifShowOrderDetail[index] = 1;
        } else {
            this.ifShowOrderDetail[index] = 0;
        }
    };

    //#region AG-Grid
    clearTable() {
        this.gridOptions.rowData = [];
        this.updateColumnDefs();
    }

    loadData() {
        this.dataLoading = true;

        this.gridOptions.columnDefs = this.setColumnDefs();
        this.gridOptions.rowData = this.datatransfer;

        switch (this.currentPage) {
            case 'badge':
                this.gridOptions.rowHeight = 60;
                break;
            default:
                this.gridOptions.rowHeight = 50;
        }
    }

    /**
     * Updates the table's column definitions based on the selected type
     */
    updateColumnDefs() {
        // Set the column defs to display the group information
        this.agGrid?.api.setGridOption('columnDefs', this.setColumnDefs());
    }

    setColumnDefs(): ColDef[] {
        let columns: ColDef[] = [];
        switch (this.currentPage) {
            case 'coin':
                columns = [
                    {
                        field: "data",
                        headerName: 'Amount',
                        width: 200,
                        valueGetter: (params) => params.data.data.CurrentPointsChange,
                        editable: (params) => (params.data.IsEdit),
                        cellEditor: 'amountClickEditRenderer',
                    },
                    {
                        field: "data",
                        headerName: 'Awarded By',
                        width: 350,
                        cellRenderer: (params) => this.coinCellRenderer(params),
                        editable: (params) => (params.data.IsEdit),
                        cellEditor: 'descriptionClickEditRenderer',
                    },
                    {
                        field: "TimeAgo",
                        headerName: 'Date',
                        width: 200,
                        editable: (params) => (params.data.IsEdit),
                        cellEditor: 'singleClickEditRenderer',
                    },
                ];
                break;
            case 'gem':
                columns = [
                    { field: "data", headerName:  this.LocalizationMessages?.Gems_Amount || "Amount", width: 125, valueGetter: (params) => params.data.data.CurrentGemsChange },
                    { field: "data", headerName: this.LocalizationMessages?.Gems_Awarded_By || "Awarded By", width: 350, cellRenderer: (params) => this.gemCellRenderer(params), },
                    { field: "TimeAgo", headerName: this.LocalizationMessages?.Gems_Date || "Date", width: 175, valueGetter: (params) => params.data.TimeAgo },
                ];
                break;
            case 'badge':
                columns = [
                    { field: "badgeName", headerName: 'Badge', width: 350, cellClass: 'font-size-16 font-weight-bold',
                        cellRenderer: (params) => this.badgeCellRenderer(params), },
                    { field: "TimeAgo", headerName: 'Earned', width: 200, cellRenderer: 'showCellRenderer', },
                ];
                break;
            case 'order':
                columns = [
                    { field: "PointStoreOrderID", headerName: 'Order Number', cellRenderer: 'agGroupCellRenderer' },
                    { field: "DateOrdered", headerName: 'Date Ordered' },

                    { field: "OrderTotal", headerName: 'Total Coins' },
                    { field: "OrderStatusName", headerName: 'Status' },
                    { field: "Note", headerName: 'Notes' },
                ];
                break;
        }
        return columns;
    }

    //pass the new value to the grid for filtering
    updateGridFilter() {
        this.agGrid?.api.onFilterChanged();
    }

    //empty search box
    clearSearch() {
        this.listFilter = "";
        this.updateGridFilter();
        this.agGrid?.api.onFilterChanged();
    }

    coinCellRenderer(params) {
        const imagePath = params.data.ImageID == undefined || params.data.ImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=&w=32&h=32' :
            `../Admin/ImageResizer.aspx?imgid=${params.data.ImageID}&w=32&h=32`;

        return `<span style="display:inline-flex;align-items:center;cursor:pointer;"><img src="${imagePath}"`
            + ` style = "border-radius: 50%;display:block;width:32px;" /> <div style="margin-left:8px;" >
            ${params.data.data.Description}</div></span> `;
    }

    badgeCellRenderer(params) {
        const imagePath = params.data.ImageID == undefined || params.data.ImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=&w=48&h=48' :
            `../Admin/ImageResizer.aspx?imgid=${params.data.ImageID}&w=48&h=48`;

        return `<span style="display:inline-flex;align-items:center;cursor:pointer;"><img src="${imagePath}"`
            + ` style="border-radius: 50%;display:block;width:48px;"/><div style="margin-left:8px;">${params.data.badgeName}</div></span>`;
    }

    gemCellRenderer(params) {
        const imagePath = params.data.ImageID == undefined || params.data.ImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=&w=48&h=48' :
            `../Admin/ImageResizer.aspx?imgid=${params.data.ImageID}&w=48&h=48`;

        return `<span style="display:inline-flex;align-items:center;cursor:pointer;"><img src="${imagePath}"`
            + ` style="border-radius: 50%;display:block;width:48px;"/><div style="margin-left:8px;">
            ${params.data.data.Description}</div></span>`;
    }

    orderCellRender(params) {
        const imagePath = params.data.ProductImageID == undefined || params.data.ImageID == 0 ?
            '../Admin/ImageResizer.aspx?imgid=&w=48&h=48' :
            `../Admin/ImageResizer.aspx?imgid=${params.data.ProductImageID}&w=48&h=48`;

        return `<span style="display:inline-flex;align-items:center;cursor:pointer;"><img src="${imagePath}"`
            + ` style="border-radius: 50%;display:block;width:48px;"/><div style="margin-left:8px;">
            ${+ params.data.Description}"</div></span>`;
    }

    addNewCoin() {
        this.loadNewData();
        this.startEditingCell();
    }

    loadNewData() {
        this.selectedNewRow = this.getNewRowData();

        const newData = [];
        newData.push(this.selectedNewRow);

        if (this.datatransfer.length > 0) {
            newData.push(...angular.copy(this.datatransfer));
        }

        this.dataLoading = true;

        this.gridOptions.rowData = JSON.parse(JSON.stringify(newData));
        this.agGrid?.api.setGridOption('rowData', newData);
        this.updateGridFilter();
    }

    getNewRowData(): AddCoinRow {
        return {
            IsEdit: true,
            CurrentPointsChange: 0,
            GivenBy: '',
            ImageID: 0,
            LastDate: "",
            TimeAgo: '',
            historyValue: 0,
            data: {
                AchievedAchievementID: 0,
                AdminID: 0,
                CompanyID: 0,
                CurrentPointsChange: 0,
                DateAvailable: '',
                Description: "",
                EventDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS').toString(),
                Level: 0,
                LoginID: 0,
                ProfileTemplateID: 0,
                ReservedPointsChange: 0,
                SpendingPointHistoryID: 0,
                isEditingCoin: false,
            },
        };
    }

    startEditingCell() {
        const startEditingParams = {
            rowIndex: 0,
            colKey: 'data',
        };
        this.agGrid?.api.startEditingCell(startEditingParams);
    }

    async saveNewCoinEntryNewData(selectedNewRow) {
        this.dataLoading = true;
        const data = selectedNewRow.data;
        if (!isNaN(data.CurrentPointsChange) && data.CurrentPointsChange != 0 && data.Description.length != 0) {
            if (data.Description.includes("/")) {
                data.Description = data.Description.replace(/\//g, "");
            }
            if (data.Description == "") {
                data.Description = "None";
            }

            await this.gameService.addSpendingHistory(this.userProfile.LoginID, data.Description, data.CurrentPointsChange);
            data.Description = "";
            data.CurrentPointsChange = 0;
            data.isEditingCoin = false;

            const response: any = await this.uAService.getCurrencyHistory(this.userProfile.LoginID);
            this.datatransfer = response;
            this.datatransferChange.emit(response);
            this.agGrid?.api.setGridOption('rowData', this.datatransfer);
            this.updateGridFilter();

            const profResponse = await this.uAService.getUserProfile(this.userProfile.LoginID);
            if (!!profResponse) {
                this.userProfile = profResponse;
                this.userProfileChange.emit(profResponse);
            }
        }
    }
    //#endregion AG-Grid
}
